/**
 * Adapted from:
 * https://gist.github.com/carlhannes/4b318c28e95f635191bffb656b9a2cfe#file-es6-async-debounce-js
 *
 * ES6 Async version of the "classic" JavaScript Debounce function.
 * Works both with and without promises, so you can replace your existing
 * debounce helper function with this one (and it will behave the same).
 *
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing.
 *
 * TODO: refactor this function and its callers to use named parameters
 *
 * @param func The function to debounce
 * @param wait The milliseconds to wait between function executions
 * @param immediate If true, execute the function immediately, then debounce subsequent calls
 */
// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
const debounce = (func: Function, wait: number, immediate: boolean = false) => {
  /**
   * Return value from setTimeout() - passed to clearTimeout() to cancel the timeout
   */
  let timeout: NodeJS.Timeout | null = null;

  /**
   * The debounced function to return
   *
   * @param args
   * @returns
   */
  const fnc = (...args: unknown[]) =>
    new Promise(resolve => {
      // if immediate is true and timeout is null, execute the function immediately
      if (immediate && !timeout) {
        Promise.resolve(func.apply(this, [...args])).then(resolve);
      }

      clearTimeout(timeout);

      timeout = setTimeout(() => {
        Promise.resolve(func.apply(this, [...args])).then(resolve);
        clearTimeout(timeout);
      }, wait);
    });

  return fnc;
};

export default debounce;

/**
 * An alternatve method of implementing an async debounce function that could be explored.
 *
 * https://github.com/szchenghuang/debounce-async/blob/master/src/index.js
 *
 * https://gist.github.com/carlhannes/4b318c28e95f635191bffb656b9a2cfe
 *
 */
